import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APICommonService } from '@nationwide/internet-servicing-angular-services';
import { Observable, empty } from 'rxjs';

import { LoggerService } from 'app/shared/services/logger.service';
import { environment } from 'environments/environment';
import { catchError } from 'rxjs/operators';
// import { PaymentDataService } from '../../shared/services/payment-data.service';
import { TokenDataService } from 'app/shared/services/token-data.service';

@Injectable()
export class AccountRetrievalService {
    constructor(private httpClient: HttpClient,
        // public paymentData: PaymentDataService,
        private apiCommonService: APICommonService,
        // public detailsService: BusinessBillingDetailsService,
        private LOGGER: LoggerService,
        private tokenDataService: TokenDataService) { }
    // parseResponse(responseJson: any): any {
    //     if (responseJson.account !== undefined && responseJson.account.accountNumber !== '') {
    //         const pastDueBill = this.detailsService.getPastDue(responseJson.account.bills);

    //         this.paymentData.remainingBalance = responseJson.account.adjustedBalance;
    //         this.paymentData.canPay = responseJson.account.indicators.canPay;
    //         this.paymentData.canPayExplanation = responseJson.account.indicators.canPayExplanation;
    //         this.paymentData.pendingPayment = responseJson.account.indicators.pendingPayment;
    //         this.paymentData.recurringSuspended = responseJson.account.indicators.recurringSuspended;
    //         this.paymentData.agentState = responseJson.account.agentState;
    //         this.paymentData.agentNumber = responseJson.account.agentNumber;

    //         if (pastDueBill && pastDueBill.billMinimumDue > 0) {
    //             this.paymentData.paymentDue = pastDueBill.billMinimumDue;
    //             this.paymentData.paymentDueDate = pastDueBill.billDueDate;
    //         } else {
    //             this.paymentData.paymentDue = responseJson.account.minimumDue;
    //             this.paymentData.paymentDueDate = responseJson.account.dueDate;
    //         }
    //     }
    // }
    retrieveAccountData(accountNumber: string, isMakeAPayment?: boolean): Observable<any> {
    const retrieveAccountUrl = `${environment.EXPERIENCE_API.ENDPOINT}accounts/${accountNumber}`;
    const authToken = this.tokenDataService.getToken();
    const sessionId = window.sessionStorage.getItem('sessionId') ?? undefined;
    const appClientId = environment.appProps.appClientId;

    let headers = this.apiCommonService.buildHeader({
        appClientId,
        authToken,
        contentType: 'text/plain',
        headerType: 'X-NW-MessageID',
        sessionId
    });

    if (isMakeAPayment) {
        headers = headers.append('X-NW-Include-Reports', 'true');
    }

    const billingRegions = window.sessionStorage.getItem('targetEnvironment') ?? `${environment.BILLING.FLEX_REGION}|${environment.BILLING.BC_REGION}`;

    if (environment.production === 'false') {
        headers = headers.append('X-NW-Target-Env', billingRegions);
    }
    return this.httpClient.get(retrieveAccountUrl, { headers })
        .pipe(
            catchError((response: Response) => {
                this.LOGGER.error('Error returning account information:', response);
                return empty();
            })
        );
    }
    // retrieveBillingAccountData(accountNumber: string): Observable<any> {
    //     const retrieveBillingAccountUrl = `${environment.BILLING.FLEX_ENDPOINT}${accountNumber}/account`;
    //     const authToken = this.tokenDataService.getToken();
    //     const appClientId = commercialConstants.appProps.appClientId;

    //     let headers = this.apiCommonService.buildHeader({
    //         appClientId,
    //         authToken,
    //         contentType: 'text/plain',
    //         headerType: 'X-NW-Message-ID'
    //     });

    //     headers = headers.append('X-NW-Consumer-Id', 'DIRECT SERVICING');

    //     let billingRegions = window.sessionStorage.getItem('targetEnvironment');
    //     if (!billingRegions) {
    //         billingRegions = `${environment.BILLING.FLEX_REGION}|${environment.BILLING.BC_REGION}`;
    //     }

    //     if (environment.production === 'false') {
    //         headers = headers.append('X-NW-Target-Env', billingRegions);
    //     }
    //     return this.httpClient.get(retrieveBillingAccountUrl, { headers })
    //         .pipe(map((response: Response) =>
    //             response),
    //             catchError((response: Response) => {
    //                 this.LOGGER.error('Error returning billing account information:', response);
    //                 return of(response);
    //             }));
    // }
}
